export default __webpack_public_path__ + "static/13-12d14c4450fa8ec8445f04fd04c4a44b.jpg";